import { FormGroup, FormBuilder, FormControl, FormArray, Validators } from '@angular/forms';
var RequestPlanningTreatmentSprayComponent = /** @class */ (function () {
    function RequestPlanningTreatmentSprayComponent(formBuilder) {
        this.formBuilder = formBuilder;
    }
    Object.defineProperty(RequestPlanningTreatmentSprayComponent.prototype, "sprayBoothStudyInstructions", {
        get: function () {
            return this.treatmentFormGroup.get('sprayBoothStudyInstructions') || this.formBuilder.group({});
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RequestPlanningTreatmentSprayComponent.prototype, "sprayEventDaysAfterPlantingList", {
        get: function () {
            return this.sprayBoothStudyInstructions.get('sprayEventDaysAfterPlantingList');
        },
        enumerable: true,
        configurable: true
    });
    RequestPlanningTreatmentSprayComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.buildTreatmentForm();
        var plannedPlantingDateControl = this.planningForm.get('plannedPlantingDate');
        if (plannedPlantingDateControl) {
            plannedPlantingDateControl.valueChanges.subscribe(function (newDate) {
                _this.formValue = newDate ? new Date(newDate) : null;
            });
        }
        this.sprayEventDaysAfterPlantingList.valueChanges.subscribe(function (values) {
            values.forEach(function (val, idx) {
                _this.existingTreatmentFormData.sprayBoothStudyInstructions[idx].sprayEventDaysAfterPlanting = val;
            });
        });
    };
    RequestPlanningTreatmentSprayComponent.prototype.ngOnChanges = function (changes) {
        if (changes.plannedPlantingDate && !changes.plannedPlantingDate.firstChange) {
            this.formValue = this.plannedPlantingDate || this.getPlannedDateFromForm();
        }
    };
    RequestPlanningTreatmentSprayComponent.prototype.buildTreatmentForm = function () {
        var controls = this.existingTreatmentFormData.sprayBoothStudyInstructions.map(function (t) { return new FormControl(t.sprayEventDaysAfterPlanting, [Validators.required, Validators.min(0)]); });
        this.sprayBoothStudyInstructions.addControl('sprayEventDaysAfterPlantingList', new FormArray(controls));
        this.formValue = this.plannedPlantingDate || this.getPlannedDateFromForm();
    };
    RequestPlanningTreatmentSprayComponent.prototype.getPlannedDateFromForm = function () {
        var plannedPlantingDate = this.planningForm.get('plannedPlantingDate').value;
        return plannedPlantingDate ? new Date(plannedPlantingDate) : null;
    };
    RequestPlanningTreatmentSprayComponent.prototype.getFormattedDate = function (index) {
        var control = this.sprayEventDaysAfterPlantingList.at(index);
        var daysToAdd = Number(control.value);
        if (!this.formValue || isNaN(daysToAdd) || daysToAdd === 0 || daysToAdd < 0)
            return '';
        var base = new Date(this.formValue);
        if (isNaN(base.getTime()))
            return '';
        base.setDate(base.getDate() + daysToAdd);
        var options = {
            weekday: 'long',
            year: '2-digit',
            month: '2-digit',
            day: '2-digit',
        };
        return base.toLocaleDateString('en-US', options);
    };
    RequestPlanningTreatmentSprayComponent.prototype.collectSprayEventData = function () {
        var _this = this;
        return this.sprayEventDaysAfterPlantingList.controls.map(function (control, index) {
            var sprayEventNumber = _this.existingTreatmentFormData.sprayBoothStudyInstructions[index].sprayEventNumber;
            var sprayEventDaysAfterPlanting = control.value;
            return { sprayEventNumber: sprayEventNumber, sprayEventDaysAfterPlanting: sprayEventDaysAfterPlanting };
        });
    };
    return RequestPlanningTreatmentSprayComponent;
}());
export { RequestPlanningTreatmentSprayComponent };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/view-request/request-planning-modal/request-planning-treatment-spray/request-planning-treatment-spray.component.ts.pre-build-optimizer.js